import cx from 'classnames'
import { ComponentType, forwardRef, PropsWithChildren } from 'react'
import { useObjectRef } from '@react-aria/utils'
import { useButton } from '@react-aria/button'
import Styles from './ImageButton.module.scss'

export interface Props extends PropsWithChildren {
  icon: ComponentType<{}>
  isActive?: boolean
  onPress: () => void
}

export const ImageButton = forwardRef<HTMLDivElement, Props>(
  ({ icon: Icon, isActive = false, onPress, children }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps, isPressed } = useButton({ onPress, elementType: 'div' }, ref)

    return (
      <div
        {...buttonProps}
        className={cx(Styles.mobileButton, {
          [Styles.active]: isActive,
          [Styles.pressed]: isPressed,
        })}
        ref={ref}
      >
        <Icon />
        <div className={Styles.label}>{children}</div>
      </div>
    )
  },
)
